/* Accessible storefront entry points. App settings and native panels stay with their providers. */
(function () {
  'use strict';
  if (window.emzCustomerTools) return;
  window.emzCustomerTools = true;
  var mobile = window.matchMedia('(max-width: 768px)');
  var compactMenu = window.matchMedia('(max-width: 1279px)');
  var chatHost, chatObserver, chatOrigin, smileOrigin, smileWasOpen = false;
  var pending = false, statusTimer;
  function visible(el) { return el && el.isConnected && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden'; }
  function focusBack(origin, kind) {
    var menu = origin && origin.closest('#NavDrawer') ? document.querySelector('#SiteHeader .js-drawer-open-nav') : null;
    var target = visible(origin) ? origin : visible(menu) ? menu : document.querySelector('.emz-mobile-tools .' + (kind === 'chat' ? 'emz-chat-trigger' : 'js-smile-rewards-trigger'));
    if (!visible(target)) target = document.querySelector(kind === 'chat' ? '.emz-footer-help .emz-chat-trigger' : '#emz-rewards-icon');
    if (visible(target)) target.focus({ preventScroll: true });
  }
  function notify(text) {
    var box = document.getElementById('emz-tools-status');
    if (!box) return;
    clearTimeout(statusTimer); box.textContent = text; box.hidden = false;
    statusTimer = setTimeout(function () { box.hidden = true; }, 8000);
  }
  function activator() {
    var host = document.querySelector('body > shopify-chat');
    var root = host && host.shadowRoot;
    var runtime = root && root.querySelector('shopify-agent-runtime');
    return runtime && runtime.shadowRoot && runtime.shadowRoot.querySelector('button[part~="activator"]');
  }
  function ready() {
    var button = activator(), host = document.querySelector('body > shopify-chat');
    document.body.classList.toggle('emz-chat-ready', !!button);
    document.body.classList.toggle('emz-rewards-ready', !!(window.SmileUI && typeof window.SmileUI.openPanel === 'function'));
    if (host && host !== chatHost) {
      if (chatObserver) chatObserver.disconnect();
      chatHost = host;
      chatObserver = new MutationObserver(function () {
        if (!host.hasAttribute('open') && chatOrigin) {
          var origin = chatOrigin; chatOrigin = null;
          setTimeout(function () { focusBack(origin, 'chat'); }, 80);
        }
      });
      chatObserver.observe(host, { attributes: true, attributeFilter: ['open'] });
    }
    return button;
  }
  var pinnedEscape = false;
  function closePinned(except, restoreFocus) {
    document.querySelectorAll('#NavDrawer .emz-menu-pinned__details[open]').forEach(function (details) {
      if (details === except) return;
      details.open = false;
      if (restoreFocus) details.querySelector('summary').focus({ preventScroll: true });
    });
  }
  document.addEventListener('pointerdown', function (event) {
    closePinned(event.target.closest('.emz-menu-pinned__details'), false);
  }, true);
  document.addEventListener('focusin', function (event) {
    // Safari focuses the drawer before a tapped link's click; keep that link visible.
    if (event.target === document.getElementById('NavDrawer')) return;
    closePinned(event.target.closest('.emz-menu-pinned__details'), false);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (pinnedEscape) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    if (!document.querySelector('#NavDrawer .emz-menu-pinned__details[open]')) return;
    event.preventDefault(); event.stopImmediatePropagation(); pinnedEscape = true;
    closePinned(null, true);
  }, true);
  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape' && pinnedEscape) {
      event.preventDefault(); event.stopImmediatePropagation(); pinnedEscape = false;
    }
  }, true);
  function decorate() {
    if (!compactMenu.matches) {
      var pinnedFocus = document.activeElement.closest('.emz-menu-pinned');
      closePinned(null, false);
      if (pinnedFocus) {
        var menuClose = document.querySelector('#NavDrawer .js-drawer-close');
        if (visible(menuClose)) menuClose.focus({ preventScroll: true });
      }
    }
    document.querySelectorAll('#SiteHeader .site-nav__link--icon').forEach(function (el) {
      var label = el.matches('.js-drawer-open-nav') ? 'Menu' : el.matches('.js-search-header') ? 'Search' : el.matches('.js-drawer-open-cart') ? 'Cart' : el.matches('.emz-theme-toggle') ? 'Appearance' : el.matches('.js-smile-rewards-trigger') ? 'Rewards' : 'Account';
      el.dataset.emzTip = label;
      if (/^(Menu|Search|Cart)$/.test(label) && !el.querySelector('.emz-icon-caption')) {
        var caption = document.createElement('span'); caption.className = 'emz-icon-caption'; caption.textContent = label; caption.setAttribute('aria-hidden', 'true'); el.appendChild(caption);
      }
    });
    var toggle = document.querySelector('.emz-theme-toggle');
    var slot = document.querySelector(mobile.matches ? '.emz-appearance-slot' : '.emz-appearance-desktop');
    if (toggle && slot && toggle.parentNode !== slot) slot.appendChild(toggle);
    if (toggle && !toggle.querySelector('.emz-appearance-label')) {
      var label = document.createElement('span'); label.className = 'emz-appearance-label'; label.textContent = 'Appearance'; toggle.appendChild(label);
    }
    if (document.querySelector('.emz-quiz')) document.querySelectorAll('.js-smile-rewards-trigger').forEach(function (el) { el.href = '/#smile-home'; });
    ready();
  }
  function closeMenu() {
    var drawer = document.getElementById('NavDrawer');
    if (!drawer || !drawer.classList.contains('drawer--is-open')) return Promise.resolve();
    var close = drawer.querySelector('.js-drawer-close');
    if (close) close.click();
    return new Promise(function (resolve, reject) {
      var tries = 0;
      var timer = setInterval(function () {
        if (!drawer.classList.contains('drawer--is-open')) { clearInterval(timer); setTimeout(resolve, 300); }
        else if (++tries >= 20) { clearInterval(timer); reject(new Error('menu')); }
      }, 50);
    });
  }
  function openTool(kind, origin) {
    var tries = 0;
    function attempt() {
      var button = ready();
      if (kind === 'chat' && button) {
        chatOrigin = origin;
        if (!chatHost.hasAttribute('open')) button.click();
        pending = false; return;
      }
      if (kind === 'rewards' && window.SmileUI && typeof window.SmileUI.openPanel === 'function') {
        smileOrigin = origin; smileWasOpen = false; window.SmileUI.openPanel(); pending = false; watchSmile(); return;
      }
      if (++tries < 12) { setTimeout(attempt, 250); return; }
      pending = false;
      if (kind === 'rewards' && window.location.hash !== '#smile-home') window.location.hash = 'smile-home';
      notify(kind === 'chat' ? 'Chat is unavailable right now. Please use Contact in the footer, or try again.' : 'Rewards is unavailable right now. Please try again shortly or use Contact in the footer.');
      focusBack(origin, kind);
    }
    attempt();
  }
  function watchSmile() {
    var count = 0;
    var timer = setInterval(function () {
      var panel = document.querySelector('#smile-ui-container .smile-panel-frame-container');
      var open = visible(panel) && panel.getBoundingClientRect().height > 20;
      if (open) smileWasOpen = true;
      if (smileWasOpen && !open) { clearInterval(timer); focusBack(smileOrigin, 'rewards'); smileOrigin = null; }
      else if (++count > 1200) clearInterval(timer);
    }, 250);
  }
  document.addEventListener('click', function (event) {
    var origin = event.target.closest('.emz-chat-trigger, .js-smile-rewards-trigger');
    if (!origin || document.querySelector('.emz-quiz')) return;
    if (origin.matches('a.emz-chat-trigger[href]') &&
        (event.defaultPrevented || (typeof event.button === 'number' && event.button !== 0) ||
         event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return;
    event.preventDefault();
    if (pending) return;
    pending = true;
    closeMenu().then(function () { setTimeout(function () { openTool(origin.matches('.emz-chat-trigger') ? 'chat' : 'rewards', origin); }, 0); }).catch(function () {
      pending = false; notify('Please close the menu and try again.');
    });
  });
  mobile.addEventListener('change', decorate);
  compactMenu.addEventListener('change', decorate);
  document.addEventListener('shopify:section:load', decorate);
  decorate();
  var checks = 0, timer = setInterval(function () { ready(); if (++checks >= 120) clearInterval(timer); }, 1000);
})();
